import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/generate-weight-mask/definition"
import {ImageOpTilingGenerateWeightMaskHal} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/generate-weight-mask/hal"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeTilingGenerateWeightMask"}

@registerImageOpNode
export class ImageOpNodeTilingGenerateWeightMask extends BasicSpecializingImageOpNode<typeof definition, ImageOpTilingGenerateWeightMaskHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpTilingGenerateWeightMaskHal, parameters)
    }
}
